import React, { Fragment } from 'react';
import { Field } from 'react-final-form';


function OperatorsSelect() {

    return (
      <Field
          className="form-control form-control-alternative"
          name="protocol"
          component="input"
          type="text"
      />
    );
}

export default OperatorsSelect;



// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/Filters/ProtocolSelect.js